export default "__VITE_ASSET__CcgqiIIk__"